import "../styles/Header.css";

function Header() {
  return (
        <header className="d-header">
        <h1 className="d-header-logo"><a className="header-link" href="/">durbo</a></h1>
        <div className="d-header-rightSection">
            <a className="header-link" href="/about">About</a>
            <a className="header-link" href="/projects">Projects</a>
            <a className="header-link" href="/contact">Contact</a>
        </div>
        </header>
  );
}

export default Header;